
/**
 *公用mixins
 */
import { setTitle } from '@/libs/utils'
import storage from 'store'
export const commonUtil = {
  data () {
    return {
      
    }
  },
  mounted() {
    this.setCurrTitle()
  },
  methods: {
    /**
     * 设置当前title
     */
    setCurrTitle() {
      let vm = this;
      this.$nextTick(() => {
        setTimeout(() => {
          if (vm.$route.meta && vm.$route.meta.title) {
            setTitle(vm.$route.meta.title)
          }
        },10)
      })
    }
  }
}
